import styled from "styled-components";

export const Tooltip = styled.div`
  padding: 10px;
  display: grid;
  gap: 8px;
  background-color: white;
  border: 1px solid gray;
`;

export const TooltipRow = styled.div<{ color?: string }>`
  color: ${({ color }) => color || "#000"};
`;
